import { render, staticRenderFns } from "./PolicyAndTerms.vue?vue&type=template&id=2eed8502&scoped=true"
import script from "./PolicyAndTerms.vue?vue&type=script&lang=js"
export * from "./PolicyAndTerms.vue?vue&type=script&lang=js"
import style0 from "./PolicyAndTerms.vue?vue&type=style&index=0&id=2eed8502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed8502",
  null
  
)

export default component.exports